import { STUDIO_DESIGN_SYSTEM_DARK_THEME, DesignSystemTheme } from '../constants';

export const designSystem: DesignSystemTheme = { ...STUDIO_DESIGN_SYSTEM_DARK_THEME };
